<form class="h-100 w-100 row m-0 p-0" [formGroup]="formMemory" (ngSubmit)="isValid()">
  <div class="col-12 mb-2">
    <h4 class="text-center">
      {{memory && memory['id'] ? 'Edición ' : 'Creación '}} de Memoria Anual
    </h4>
  </div>
  <div class="col-12 vs-outline-editCard h-fit-content my-3">
    <img class="given-img mw-100" [src]="img64 || memory['img'] | safeDom" alt="img-benefit-slide"
         *ngIf="img64 || ( memory && memory['img'])">
    <div class="btn-custom-file h-100 w-100">
      <label for="file-image" class="custom-file-upload mt-4">
        <mat-icon>{{!img64 && !(memory && memory['img'])  ? 'image': '' }} </mat-icon>
        <span class="my-2 text-center">{{memory ? 'Editar ' : 'Agregar'}}
          imagen</span>
      </label>
      <input id="file-image" accept="image/*" type="file" (change)="image64($event)"/>
    </div>
  </div>
  <div class="col-12 vs-outline-editCard h-fit-content my-3 flex-column">
    <div class="btn-custom-file h-100 w-100">
      <label for="file-pdf" class="custom-file-upload mt-4">
        <mat-icon>picture_as_pdf</mat-icon>
        <span class="my-2 text-center">{{memory ? 'Editar ' : 'Agregar'}}
          PDF</span>
      </label>
      <input id="file-pdf" accept="application/pdf" type="file" (change)="file64($event)"/>
    </div>
    <div class="w-100 d-flex justify-content-center mb-3">
      <mat-hint *ngIf="pdfName">Archivo cargado:{{pdfName}}</mat-hint>
    </div>
  </div>
  <a class="vs-btn-blue vs-btn-outline mb-3" *ngIf="pdfAttached" [href]="pdfAttached"
     target="_blank">
    Ver PDF actual
  </a>
  <div class="col-12 my-1 px-xl-0">
    <mat-form-field class="example-full-width w-100" appearance="outline">
      <mat-label>Título</mat-label>
      <input formControlName="name" matInput placeholder="Ingresar título..." type="text">
      <mat-hint align="end">Ejemplo: Memoria 2021...</mat-hint>
    </mat-form-field>
  </div>
  <div class="col-12 mb-2 px-xl-0">
    <mat-form-field class="example-full-width w-100" appearance="outline">
      <mat-label>Orden</mat-label>
      <input formControlName="orderId" matInput placeholder="Ingresar lugar de orden..." type="number">
      <mat-hint align="end">Ejemplo: 1,2,3...</mat-hint>
    </mat-form-field>
  </div>
  <button type="submit" class="vs-btn-blue" [disabled]="formMemory.invalid">
    {{memory && memory['id'] ? 'Editar ' : 'Crear '}}
    Memoria Anual
  </button>
</form>
